import {
	AppBar,
	Button,
	Checkbox,
	Dialog,
	FormControlLabel,
	FormGroup,
	IconButton,
	InputLabel,
	Menu,
	MenuItem,
	Radio,
	RadioGroup,
	Slide,
	Step,
	StepLabel,
	Stepper,
	TextField,
	Toolbar,
	WithStyles,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from '../reducers';
import SiteConfig from '../site.config.json';

import CloseIcon from '@material-ui/icons/Close';
import CareerDetail from './CareerDetail';

import indigo from '@material-ui/core/colors/indigo';
import SearchIcon from '@material-ui/icons/Search';
import { DropzoneArea } from 'material-ui-dropzone';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { IMessage } from 'src/actions/message';
import CustomDatePicker from 'src/components/CustomDatePicker';
import MessageDialog from 'src/components/MessageDialog';
import i18n from 'src/resources/i18n';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import Progress from '../components/Progress';
import ScenarioFactory, {
	IParam,
} from '../scenario/QuickModeStudentAssignScenarioFactory';
import InputCheck from '../utils/InputCheck';
import { getSystemMst, MasterItemCode } from '../utils/MasterData';
const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		butPosition: {
			display: 'table',
			margin: '0 auto',
			marginTop: '11px',
		},
		button: {
			'&:hover': {
				backgroundColor: '#5c9128',
			},
			backgroundColor: '#6fb727',
			borderRadius: '10px',
			fontSize: '1.2rem',
			height: '40px',
			width: '150px',
		},
		careerDialog: {
			width: '80%',
		},
		checkbox: {
			height: 36,
			width: 36,
		},
		classStyles: {
			alignItems: 'top',
			display: 'inline-block',
			margin: '5px',
		},
		classStylesItem: {
			display: 'inline-block',
		},
		container: {
			'-webkit-align-items': 'center',
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',
		},
		dateStyle: {
			'-webkit-align-items': 'center',
			cursor: 'pointer',
			display: 'flex',
			flexWrap: 'wrap',
			paddingLeft: '15px',
		},
		logButton: {
			borderRadius: '10px',
			fontSize: '1.2rem',
			height: '40px',
			marginLeft: '20px',
			width: '150px',
		},
		paper: {
			height: 'auto',
			padding: theme.spacing(1.5),
		},
		placeholder: {
			marginBottom: 0,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: 0,
			textAlign: 'center',
			width: 250,
			[theme.breakpoints.up('md')]: {
				height: 284,
			},
		},
		pointer: {
			cursor: 'pointer',
		},
		root: {
			flexGrow: 1,
			padding: '0.5% 1% 0% 1%',
			wordBreak: 'break-all',
		},
		steperWidth: {
			'@media (max-width: 600px)': {
				width: '100%',
			},
			height: '20px',
			width: '80%',
		},

		dropzoneInput: {
			background: '#fff',
			borderColor: '#516ecb',
			borderRadius: '8px',
			margin: '20px',
			maxHeight: '105px',
			minHeight: '105px',
			width: '280px',
		},
		icon: {
			display: 'none',
		},
		tableStyle: {
			height: '434px',
		},
		text: {
			margin: '0px',
		},
		textContainer: {
			display: 'table-cell',
			height: '100px',
			padding: '30px 10px',
			textAlign: 'center',
			verticalAlign: 'middle',
			width: '280px',
		},
		textStyle: {
			color: '#516ecb',
			fontSize: '25px',
		},
		textStyle_fileName: {
			'-webkit-box-orient': 'vertical',
			'-webkit-line-clamp': '2',
			color: '#516ecb',
			display: '-webkit-box',
			fontSize: '15px',
			overflow: 'hidden',
			textAlign: 'center',
		},
		title: {
			fontWeight: 'bold',
		},

		freewordStyle: {
			width: '75%',
		},
		jissiKikanSet: {
			marginTop: 10,
			padding: theme.spacing(1.5),
		},
		noticeText: {
			fontSize: '100%',
			height: '40px',
			marginLeft: '20px',
			wordWrap: 'break-word',
		},

		link: {
			color: indigo[700],
			cursor: 'pointer',
		},

		image_downLoad: {
			cursor: 'pointer',
			height: '85px',
			margin: '20px',
			width: '110px',
		},
		uploadProgress: {
			color: theme.palette.primary.main,
			left: '50%',
			marginLeft: -12,
			marginTop: -12,
			position: 'absolute',
			top: '50%',
		},
	});

interface IState {
	steps: string[];
	vertical: boolean;
	orgID: string; // 前画面渡した組織ID
	openCareerDetailDialog: boolean;
	careerId: string;
	fileName: string;
	files: File[];
	freeword: string;
	jissiKikanType: string;
	openEndDate: string;
	openStartDate: string;
	endDateByYear: string;
	endDateByDay: string;
	messages: IMessage[];
	openErrorMessageDialog: boolean;
	selectColumnsMenuAnchorEl?: HTMLElement;
	selectedColumns: number[];
	selectedCareers: string[];
	messageTitle: string;
	loading: boolean;
	downloadImageSrc: string;
}

/**
 * コンテンツ配信画面メイン
 */
class QuickModeStudentAssign extends React.Component<IProps, IState> {
	protected templateDownloadForm: React.RefObject<HTMLFormElement>;
	protected assignStudentLogDownloadForm: React.RefObject<HTMLFormElement>;

	constructor(props: IProps) {
		super(props);
		this.state = {
			careerId: '',
			downloadImageSrc: 'light',
			endDateByDay: '',
			endDateByYear: '',
			fileName: '',
			files: [],
			freeword: '',
			jissiKikanType: '2',
			loading: false,
			messageTitle: '',
			messages: [],
			openCareerDetailDialog: false,
			openEndDate: '',
			openErrorMessageDialog: false,
			openStartDate: '',
			orgID: this.props.location.state.org_Id,
			selectedCareers: [],
			selectedColumns: [0, 1, 2],
			steps: [
				i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE13'),
				i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE14'),
			],
			vertical: false,
		};
		this.templateDownloadForm = React.createRef();
		this.assignStudentLogDownloadForm = React.createRef();
		this.changeDate = this.changeDate.bind(this);
		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.commit = this.commit.bind(this);
		this.check = this.check.bind(this);
		this.handleShowDetailDialog = this.handleShowDetailDialog.bind(this);
		this.mouseOver = this.mouseOver.bind(this);
		this.mouseLeave = this.mouseLeave.bind(this);
	}

	public dropRejected = (files: File[], event: any) => {
		if (files) {
			this.getFileAndValidate(files);
		}
	};

	public drop = (files: File[], event: any) => {
		if (files) {
			this.getFileAndValidate(files);
		}
		this.setState({ files });
	};

	// ファイルチェックをアップロード「drop　here」
	public getFileAndValidate = async (files: File[]) => {
		const messages: IMessage[] = [];
		const FileName: string = files[0].name;
		if (!FileName.endsWith('.xlsm')) {
			// ファイル拡張子.xlsmでない場合、エラーメッセージが表示する。
			const message: IMessage = {
				content: 'LMCM_E_15505',
			};
			messages.push(message);
		}
		// メッセージを表示する。
		if (messages.length !== 0) {
			this.setState({
				messageTitle: i18n.t('QUICKMODE_STUDENT_ASSIGN_ERRTEXT01'),
				messages,
				openErrorMessageDialog: true,
			});
		} else {
			this.setState({
				fileName: FileName,
			});
		}
	};

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		const param: IParam = {
			freeword: this.state.freeword,
			orgID: this.state.orgID,
		};
		this.props.fetchCareerList(this.props.token, param);
	}

	/**
	 * レンダリング
	 */
	public render(): JSX.Element {
		const { classes, data } = this.props;
		const selected = this.state.selectedCareers.length;
		const indicator = selected
			? `${selected}${i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE12')}`
			: '';
		const DropzoneAreaBaseClasses = {
			icon: classes.icon,
			text: classes.text,
			textContainer: classes.textContainer,
		};
		const columns = this.getSelectedColumns();
		return (
			<div className={classes.root}>
				<Progress open={this.state.loading} />
				<Grid container={true} spacing={2} alignItems="stretch">
					<Grid item={true} xs={12} md={true}>
						<Grid item={true} xs={12} md={true}>
							<Paper className={classes.paper}>
								<Grid
									container={true}
									direction="column"
									alignItems="stretch"
									wrap="nowrap"
								>
									<Grid item={true}>
										<Typography
											variant="h6"
											color="primary"
											className={classes.title}
										>
											{i18n.t(
												'QUICKMODE_STUDENT_ASSIGN_TITLE01'
											)}
										</Typography>
										<p className={classes.noticeText}>
											{i18n.t(
												'QUICKMODE_STUDENT_ASSIGN_NOTICETEXT'
											)}
										</p>
										<Stepper
											orientation={
												this.state.vertical
													? 'vertical'
													: 'horizontal'
											}
											className={classes.steperWidth}
										>
											{this.state.steps.map((step, i) => {
												return (
													<Step key={i} active={true}>
														<StepLabel>
															{step}
														</StepLabel>
													</Step>
												);
											})}
										</Stepper>
										<div className={classes.container}>
											<Grid item={true} xs={3} md={true}>
												<img
													src={require('../images/download_' +
														this.state
															.downloadImageSrc +
														'.png')}
													className={
														classes.image_downLoad
													}
													onMouseOver={this.mouseOver}
													onMouseLeave={
														this.mouseLeave
													}
													onClick={
														this
															.handleDownloadTemplate
													}
												/>
												<form
													method="POST"
													action={
														SiteConfig.tsqPath +
														'/tsq/pkg/action/per/userTemplateFileDownload.action'
													}
													ref={
														this
															.templateDownloadForm
													}
													target="_blank"
												>
													<input
														type="hidden"
														name="orgID"
														value={this.state.orgID}
													/>
												</form>
											</Grid>
											<Grid item={true} xs={3} md={true}>
												<DropzoneArea
													acceptedFiles={['.xlsm']}
													classes={
														DropzoneAreaBaseClasses
													}
													dropzoneText={
														this.state.fileName
															? this.state
																	.fileName
															: 'drop here'
													}
													dropzoneClass={
														classes.dropzoneInput
													}
													dropzoneParagraphClass={
														this.state.fileName
															? classes.textStyle_fileName
															: classes.textStyle
													}
													filesLimit={1}
													showAlerts={false}
													showPreviews={false}
													showPreviewsInDropzone={
														false
													}
													showFileNamesInPreview={
														false
													}
													onDropRejected={
														this.dropRejected
													}
													onDrop={this.drop}
												/>
											</Grid>
										</div>
									</Grid>
								</Grid>
							</Paper>
						</Grid>
						<Grid item={true} xs={12} md={true}>
							<Paper className={classes.jissiKikanSet}>
								<Grid
									container={true}
									direction="column"
									alignItems="stretch"
									wrap="nowrap"
								>
									<Grid item={true}>
										<Typography
											variant="h6"
											color="primary"
											className={classes.title}
										>
											{i18n.t(
												'QUICKMODE_STUDENT_ASSIGN_TITLE02'
											)}
										</Typography>
										<Grid item={true}>
											<RadioGroup
												aria-label="jissiKikan-type"
												name="jissiKikanType"
												value={
													this.state.jissiKikanType
												}
												onChange={this.changeData}
											>
												<Grid
													className={
														classes.classStyles
													}
												>
													<FormControlLabel
														value="0"
														control={<Radio />}
														label={i18n.t(
															'QUICKMODE_STUDENT_ASSIGN_TITLE03'
														)}
													/>
													<Grid
														className={
															classes.classStylesItem
														}
													>
														<FormGroup row={true}>
															<FormControlLabel
																control={
																	<TextField
																		autoFocus={
																			true
																		}
																		id="endDateByYear"
																		value={
																			this
																				.state
																				.endDateByYear
																		}
																		disabled={
																			!(
																				this
																					.state
																					.jissiKikanType ===
																				'0'
																			)
																		}
																		onChange={
																			this
																				.changeData
																		}
																	/>
																}
																label={i18n.t(
																	'QUICKMODE_STUDENT_ASSIGN_TITLE04'
																)}
															/>
														</FormGroup>
													</Grid>
												</Grid>
												<Grid
													className={
														classes.classStyles
													}
												>
													<FormControlLabel
														value="1"
														control={<Radio />}
														label={i18n.t(
															'QUICKMODE_STUDENT_ASSIGN_TITLE05'
														)}
													/>
													<Grid
														className={
															classes.classStylesItem
														}
													>
														<FormGroup row={true}>
															<FormControlLabel
																control={
																	<TextField
																		autoFocus={
																			true
																		}
																		id="endDateByDay"
																		value={
																			this
																				.state
																				.endDateByDay
																		}
																		disabled={
																			!(
																				this
																					.state
																					.jissiKikanType ===
																				'1'
																			)
																		}
																		onChange={
																			this
																				.changeData
																		}
																	/>
																}
																label={i18n.t(
																	'QUICKMODE_STUDENT_ASSIGN_TITLE06'
																)}
															/>
														</FormGroup>
													</Grid>
												</Grid>

												<Grid
													className={
														classes.classStyles
													}
												>
													<FormControlLabel
														value="2"
														control={<Radio />}
														label={i18n.t(
															'QUICKMODE_STUDENT_ASSIGN_TITLE07'
														)}
													/>
													<Grid
														className={
															classes.classStylesItem
														}
													>
														<FormGroup row={true}>
															<Grid
																container={true}
																spacing={3}
																alignItems="flex-end"
																className={
																	classes.dateStyle
																}
															>
																<Grid
																	item={true}
																>
																	<CustomDatePicker
																		name="openStartDate"
																		value={
																			this
																				.state
																				.openStartDate
																		}
																		disabled={
																			!(
																				this
																					.state
																					.jissiKikanType ===
																				'2'
																			)
																		}
																		onChange={
																			this
																				.changeDate
																		}
																	/>
																</Grid>
																<Grid
																	item={true}
																>
																	～
																</Grid>
																<Grid
																	item={true}
																>
																	<CustomDatePicker
																		name="openEndDate"
																		value={
																			this
																				.state
																				.openEndDate
																		}
																		disabled={
																			!(
																				this
																					.state
																					.jissiKikanType ===
																				'2'
																			)
																		}
																		onChange={
																			this
																				.changeDate
																		}
																	/>
																</Grid>
															</Grid>
														</FormGroup>
													</Grid>
												</Grid>
											</RadioGroup>
										</Grid>
									</Grid>
								</Grid>
							</Paper>
						</Grid>
					</Grid>
					<Grid item={true} xs={true} md={true}>
						<Paper className={classes.paper}>
							<Typography
								variant="h6"
								color="primary"
								className={classes.title}
							>
								{i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE08')}
							</Typography>
							<TextField
								autoFocus={true}
								label={i18n.t(
									'QUICKMODE_STUDENT_ASSIGN_TITLE15'
								)}
								id="freeword"
								value={this.state.freeword}
								onChange={this.changeData}
								className={classes.freewordStyle}
							/>
							<Button
								onClick={this.search}
								variant="contained"
								color="primary"
							>
								<SearchIcon />
							</Button>
							<div className={classes.tableStyle}>
								<ReactTable
									data={data}
									columns={columns}
									defaultPageSize={5}
									className="-striped -highlight"
									getTrGroupProps={this.getTrGroupProps(
										classes
									)}
									indicator={indicator}
									columnsMenu={true}
									menuHandler={this.handleSelectColumns}
									heightStyle={'331px'}
								/>
								{this.getSelectColumnsMenu()}
							</div>
						</Paper>
					</Grid>
				</Grid>
				<div className={classes.butPosition}>
					<Button
						variant="contained"
						color="primary"
						onClick={this.commit}
						className={classes.button}
						disabled={this.state.loading === true}
					>
						{i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE09')}
					</Button>
					<Button
						variant="contained"
						color="primary"
						onClick={this.downloadLogFile}
						className={classes.logButton}
					>
						{i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE11')}
					</Button>
					<form
						method="POST"
						action={
							SiteConfig.tsqPath +
							'/tsq/pkg/action/per/assignStudentLogFileDownload.action'
						}
						ref={this.assignStudentLogDownloadForm}
						target="_blank"
					/>
				</div>
				<Dialog
					fullScreen={false}
					TransitionComponent={Transition}
					open={this.state.openCareerDetailDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE10')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CareerDetail careerID={this.state.careerId} />
				</Dialog>
				<MessageDialog
					open={this.state.openErrorMessageDialog}
					showCancelButton={false}
					title={this.state.messageTitle}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
			</div>
		);
	}

	/**
	 * 行プロパティ
	 */
	protected getTrGroupProps = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}
		const { careerId } = rowInfo.original;
		const isSelected = this.isIncludeSelectedColumns(careerId);
		let className: string = '';
		if (isSelected) {
			className = classes.selectedRow;
		}

		return { className };
	};

	/**
	 * 選択済みかどうかをチェック
	 * @param careerId 研修ID
	 */
	protected isIncludeSelectedColumns(careerId: string) {
		let isInclude = false;
		for (const selectedCareerId of this.state.selectedCareers) {
			if (selectedCareerId === careerId) {
				isInclude = true;
				break;
			}
		}
		return isInclude;
	}

	/**
	 * 表示カラム選択ボタン
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};
	/**
	 * 表示カラム選択メニュークローズ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * カラム選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		const allColumns = this.getAllColumns();
		const checkboxList: any[] = [];

		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					checked: this.state.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);

		return (
			<Menu
				id="select-column-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
								color="primary"
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * 表示カラム変更処理
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.state.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}
		this.setState({ selectedColumns: newSelectedColumns });
	};

	/**
	 * 選択カラム取得
	 */
	protected getSelectedColumns() {
		const columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.state.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		return columns;
	}
	/**
	 * カラム表示制御
	 */
	protected getAllColumns() {
		return [
			{
				Cell: (row: RowRenderProps) => {
					const checked = this.isIncludeSelectedColumns(
						row.original.careerId
					);
					return (
						<div>
							{row.original.check !== null && (
								<Checkbox
									className={this.props.classes.checkbox}
									data-careerid={row.original.careerId}
									onClick={this.selectedCareers}
									checked={checked}
									color="primary"
								/>
							)}
						</div>
					);
				},
				Header: '',
				accessor: 'check',
				required: true,
				sortable: false,
				width: 50,
			},
			{
				Header: i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE16'),
				accessor: 'careerId',
				minWidth: 100,
			},
			{
				Cell: (row: RowRenderProps) => {
					return (
						<span
							className={this.props.classes.link}
							data-careerid={row.original.careerId}
							onClick={this.handleShowDetailDialog}
						>
							{row.original.careerTitle}
						</span>
					);
				},
				Header: i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE17'),
				accessor: 'careerTitle',
				minWidth: 120,
			},
		];
	}

	/**
	 * 選択中の研修ID取得
	 */
	protected selectedCareers = (event: React.MouseEvent<HTMLElement>) => {
		const selecteCareerId = event.currentTarget.getAttribute(
			'data-careerid'
		);
		const selectedCareers = this.state.selectedCareers;
		if (selecteCareerId && selecteCareerId !== '') {
			if (selectedCareers.length > 0) {
				const includes = selectedCareers.includes(selecteCareerId);
				if (includes) {
					const inx = selectedCareers.findIndex(
						id => id === selecteCareerId
					);
					selectedCareers.splice(inx, 1);
				} else {
					selectedCareers.push(selecteCareerId);
				}
			} else {
				selectedCareers.push(selecteCareerId);
			}
		}
		this.setState({ selectedCareers });
	};
	/**
	 * テンプレートのダウンロード押下時ハンドラ
	 */
	protected handleDownloadTemplate = () => {
		this.props
			.fetchExcelFileDownload(this.props.token, this.state.orgID)
			.then(() => {
				if (this.props.excelResult) {
					if (this.props.excelResult === '0') {
						const messages: IMessage[] = [];
						const message: IMessage = {
							content: 'LMCM_E_15506',
						};
						messages.push(message);
						// メッセージを表示する。
						if (messages.length !== 0) {
							this.setState({
								messageTitle: i18n.t(
									'QUICKMODE_STUDENT_ASSIGN_ERRTEXT01'
								),
								messages,
								openErrorMessageDialog: true,
							});
						}
						return;
					} else if (this.props.excelResult === '1') {
						if (this.templateDownloadForm.current) {
							this.templateDownloadForm.current.submit();
						}
					}
				}
			});
	};

	protected mouseOver() {
		this.setState({
			downloadImageSrc: 'deep',
		});
	}

	protected mouseLeave() {
		this.setState({
			downloadImageSrc: 'light',
		});
	}
	/**
	 * 受講期間設定の条件変更
	 */
	protected changeData = (
		event: React.ChangeEvent<HTMLInputElement>,
		value?: any
	) => {
		const target = event.target as HTMLInputElement;
		const val = value !== undefined ? value : target.value;
		switch (target.id || target.name) {
			case 'jissiKikanType':
				// 受講期間設定が変わった場合は、選択条件をクリア
				if (target.value === '0') {
					this.setState({
						endDateByDay: '',
						openEndDate: '',
						openStartDate: '',
					});
				} else if (target.value === '1') {
					this.setState({
						endDateByYear: '',
						openEndDate: '',
						openStartDate: '',
					});
				} else {
					this.setState({
						endDateByDay: '',
						endDateByYear: '',
					});
				}
				this.setState({
					jissiKikanType: val,
				});
				break;
			case 'endDateByYear':
				// 「期間設定（年）」のテキスト変更処理
				this.setState({
					endDateByYear: val,
				});
				break;
			case 'endDateByDay':
				// 「期間設定（日）」のテキスト変更処理
				this.setState({
					endDateByDay: val,
				});
				break;
			case 'freeword':
				// フリーワードのテキスト変更処理
				this.setState({
					freeword: val,
				});
				break;
		}
	};

	/**
	 * 受講期間設定の日程指定-指定日付変更処理
	 * @param name プロパティ名
	 * @param dateStr 日付
	 */
	protected changeDate(name: string, dateStr: string) {
		if (name === 'openStartDate') {
			// 開始日
			this.setState({
				openStartDate:
					dateStr !== '' ? dateStr + ' ' + '00:00' : dateStr,
			});
		} else {
			// 終了日
			this.setState({
				openEndDate: dateStr !== '' ? dateStr + ' ' + '23:59' : dateStr,
			});
		}
	}

	/**
	 * 検索処理
	 */
	protected search = (event: React.MouseEvent<HTMLElement>) => {
		const param: IParam = {
			freeword: this.state.freeword.substring(0, 500),
			orgID: this.state.orgID,
		};
		this.props.fetchCareerList(this.props.token, param);
	};

	/**
	 * 一括受講者登録
	 * @param event イベントオブジェクト
	 */
	protected commit(event: React.MouseEvent<HTMLElement>) {
		if (!this.check()) {
			return;
		}
		const applicationCheckNumber = getSystemMst(
			MasterItemCode.QM_APPLICATION_CHECK_NUMBER
		);
		const param = this.state;
		this.setState({ loading: true });
		const messages: IMessage[] = [];
		// ファイルをアップロード
		const form = new FormData();
		const modelData = {
			per_quickMode_applicationUserUpload: {
				accessType: '21',
				applicationCheckNumber,
				careerIDs: param.selectedCareers,
				companyId: this.state.orgID,
				endDateByDay: param.endDateByDay,
				endDateByYear: param.endDateByYear,
				jissiKikanType: param.jissiKikanType,
				menuItemType: 'STUDENT_ASSIGN_MENU_ITEM',
				openEndDate: param.openEndDate,
				openStartDate: param.openStartDate,
			},
		};
		form.append('__modelData', JSON.stringify(modelData));
		form.append('__file', param.files[0]);
		const request = new XMLHttpRequest();
		request.open(
			'POST',
			SiteConfig.tsqPath + '/tsq/ui/common/resources/rest/file/upload',
			true
		);
		request.setRequestHeader('Accept', 'application/json');
		request.send(form);
		request.onreadystatechange = () => {
			this.setState({ loading: false });
			if (request.readyState === 4 && request.status === 200) {
				const response = JSON.parse(request.responseText);
				if (response.per_quickMode_applicationUserUpload) {
					const errorMessage =
						response.per_quickMode_applicationUserUpload
							.errorMessageList;
					if (errorMessage && errorMessage.length !== 0) {
						const message: IMessage = {
							content: errorMessage[0].messageId,
							replacements: errorMessage[0].replacementStringList,
						};
						let messageTitle: string = '';
						if (errorMessage[0].messageId === 'LMCM_E_15509') {
							messageTitle = i18n.t(
								'QUICKMODE_STUDENT_ASSIGN_ERRTEXT03'
							);
						} else {
							messageTitle = i18n.t(
								'QUICKMODE_STUDENT_ASSIGN_ERRTEXT01'
							);
						}
						if (messages.length === 0) {
							messages.push(message);
							this.setState({
								messageTitle,
								messages,
								openErrorMessageDialog: true,
							});
						}
					}
				}
			}
		};
	}
	/**
	 * 入力チェック
	 * @param applyFlg 申請フラグ
	 * @returns true: OK、false: NG
	 */
	protected check(): boolean {
		const messages: IMessage[] = [];
		const data = this.state;
		const type = data.jissiKikanType;
		let careerNumber = 0;
		const str = getSystemMst(MasterItemCode.QM_CAREER_NUMBER);
		if (str) {
			careerNumber = parseInt(str, 10);
		}
		switch (type) {
			// 受講期間設定は「期間設定（年）」を指定する場合
			case '0':
				// 年間は未入力する場合
				if (!data.endDateByYear || data.endDateByYear.length === 0) {
					const message: IMessage = {
						content: 'CHK_E_0001',
						replacements: [
							i18n.t('QUICKMODE_STUDENT_ASSIGN_LEFT') +
								i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE03') +
								i18n.t('QUICKMODE_STUDENT_ASSIGN_RIGHT'),
						],
					};
					messages.push(message);
				} else {
					// 年間に0-99の半角数字以外を入力する場合
					if (
						!InputCheck.IsNumberOrBlank(data.endDateByYear) ||
						parseInt(data.endDateByYear, 10) < 1 ||
						parseInt(data.endDateByYear, 10) > 99
					) {
						const message: IMessage = {
							content: 'LMCM_E_15500',
							replacements: [
								i18n.t('QUICKMODE_STUDENT_ASSIGN_LEFT') +
									i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE03') +
									i18n.t('QUICKMODE_STUDENT_ASSIGN_RIGHT'),
							],
						};
						messages.push(message);
					}
				}
				break;
			// 受講期間設定は「期間設定（日）」を指定する場合
			case '1':
				// 日間は未入力する場合
				if (!data.endDateByDay || data.endDateByDay.length === 0) {
					const message: IMessage = {
						content: 'CHK_E_0001',
						replacements: [
							i18n.t('QUICKMODE_STUDENT_ASSIGN_LEFT') +
								i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE05') +
								i18n.t('QUICKMODE_STUDENT_ASSIGN_RIGHT'),
						],
					};
					messages.push(message);
				} else {
					// 日間に0-9999の半角数字以外を入力する場合
					if (
						!InputCheck.IsNumberOrBlank(data.endDateByDay) ||
						parseInt(data.endDateByDay, 10) < 1 ||
						parseInt(data.endDateByDay, 10) > 9999
					) {
						const message: IMessage = {
							content: 'LMCM_E_15501',
							replacements: [
								i18n.t('QUICKMODE_STUDENT_ASSIGN_LEFT') +
									i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE05') +
									i18n.t('QUICKMODE_STUDENT_ASSIGN_RIGHT'),
							],
						};
						messages.push(message);
					}
				}
				break;
			// 受講期間設定は「日程指定」を指定する場合
			case '2':
				const errCol: string[] = [];
				const startDateErrCol: string[] = [];
				const endDateErrCol: string[] = [];
				// 必須入力チェック
				if (!data.openStartDate || data.openStartDate.length === 0) {
					errCol.push(
						i18n.t('QUICKMODE_STUDENT_ASSIGN_OPENSTARTDATE')
					);
				} else {
					// 開始日時のフォーマットチェック
					if (
						InputCheck.chkErYYYYMMDDhhmm(
							InputCheck.convertDate(data.openStartDate)
						)
					) {
						startDateErrCol.push(
							i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE02')
						);
					} else if (
						data.openStartDate < '1900/01/01 00:00' ||
						data.openStartDate > '2100/01/01 23:59'
					) {
						startDateErrCol.push(
							i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE02')
						);
					}
					// 開始日時のフォーマットが「yyyy/mm/dd hh:mm」ではない場合
					if (startDateErrCol.length > 0) {
						const message: IMessage = {
							content: 'LMCM_E_00457',
							replacements: [
								InputCheck.makeErrColListString(
									startDateErrCol
								),
							],
						};
						messages.push(message);
					}
				}
				if (!data.openEndDate || data.openEndDate.length === 0) {
					errCol.push(i18n.t('QUICKMODE_STUDENT_ASSIGN_OPENENDDATE'));
				} else {
					// 終了日時のフォーマットチェック
					if (
						InputCheck.chkErYYYYMMDDhhmm(
							InputCheck.convertDate(data.openEndDate)
						)
					) {
						endDateErrCol.push(
							i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE02')
						);
					} else if (
						data.openEndDate < '1900/01/01 00:00' ||
						data.openEndDate > '2100/01/01 23:59'
					) {
						endDateErrCol.push(
							i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE02')
						);
					}
					// 終了日時のフォーマットが「yyyy/mm/dd hh:mm」ではない場合
					if (endDateErrCol.length > 0) {
						const message: IMessage = {
							content: 'LMCM_E_00459',
							replacements: [
								InputCheck.makeErrColListString(endDateErrCol),
							],
						};
						messages.push(message);
					}
				}
				if (errCol.length > 0) {
					const message: IMessage = {
						content: 'CHK_E_0001',
						replacements: [InputCheck.makeErrColListString(errCol)],
					};
					messages.push(message);
				}
				// 日時前後チェック
				if (
					startDateErrCol.length === 0 &&
					endDateErrCol.length === 0 &&
					data.openStartDate &&
					data.openEndDate &&
					InputCheck.chkFuturePast(
						data.openStartDate,
						data.openEndDate
					) === 1
				) {
					// 開始日時より前の日時日付を指定する場合
					const message: IMessage = {
						content: 'LMCM_E_00460',
						replacements: [
							i18n.t('QUICKMODE_STUDENT_ASSIGN_TITLE02'),
						],
					};
					messages.push(message);
				}

				break;
		}
		// 研修選択と未選択チェック
		if (!data.selectedCareers || data.selectedCareers.length === 0) {
			// 研修は未選択の場合
			const message: IMessage = {
				content: 'LMCM_E_15502',
			};
			messages.push(message);
		} else if (data.selectedCareers.length > careerNumber) {
			// 選択した研修の数は10件※以上の場合
			const message: IMessage = {
				content: 'LMCM_E_15504',
				replacements: [careerNumber.toString()],
			};
			messages.push(message);
		}
		// ファイルをアップロードチェック
		if (!data.files || data.files.length === 0) {
			// テンプレートをアップロードしない場合
			const message: IMessage = {
				content: 'LMCM_E_15503',
			};
			messages.push(message);
		}
		// メッセージを表示する。
		if (messages.length !== 0) {
			this.setState({
				messageTitle: i18n.t('QUICKMODE_STUDENT_ASSIGN_ERRTEXT01'),
				messages,
				openErrorMessageDialog: true,
			});
			return false;
		} else {
			return true;
		}
	}
	/**
	 * ログ処理(read module)
	 * event: React.MouseEvent<HTMLElement>
	 */
	protected downloadLogFile = () => {
		this.props.fetchLogFileDownload(this.props.token).then(() => {
			if (this.props.result) {
				if (this.props.result === '0') {
					const messages: IMessage[] = [];
					const message: IMessage = {
						content: 'LMCM_E_15508',
					};
					messages.push(message);
					// メッセージを表示する。
					if (messages.length !== 0) {
						this.setState({
							messageTitle: i18n.t(
								'QUICKMODE_STUDENT_ASSIGN_ERRTEXT01'
							),
							messages,
							openErrorMessageDialog: true,
						});
					}
					return;
				} else if (this.props.result === '1') {
					if (this.assignStudentLogDownloadForm.current) {
						this.assignStudentLogDownloadForm.current.submit();
					}
				}
			}
		});
	};

	/**
	 * エラーメッセージクローズ
	 */
	protected errorMessageDialogClose() {
		this.setState({
			messageTitle: '',
			messages: [],
			openErrorMessageDialog: false,
		});
	}

	protected handleShowDetailDialog = (
		event: React.MouseEvent<HTMLElement>
	) => {
		const dataCareerID = event.currentTarget.getAttribute('data-careerid');
		if (dataCareerID) {
			this.setState({
				careerId: dataCareerID,
				openCareerDetailDialog: true,
			});
		}
	};

	protected handlecloseDetailDialog = () => {
		this.setState({ careerId: '', openCareerDetailDialog: false });
	};
	/**
	 * プレースホルダコンポーネント
	 */
	protected Placeholder: React.SFC<{ text: string }> = props => {
		return (
			<div className={this.props.classes.placeholder}>
				<Typography variant="caption">{props.text}</Typography>
			</div>
		);
	};
}

const mapStateToProps = (state: IRootState) => ({
	data: state.studentAssignState.searchListItem,
	excelResult: state.studentAssignState.searchExceldata,
	interval: state.login.carouselChangeInterval,
	result: state.studentAssignState.searchLogFile,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCareerList: (token: string, param: IParam) => {
		const s = ScenarioFactory.createFetchCareerList(dispatch, token);
		s.run(param);
	},
	fetchExcelFileDownload: (token: string, orgId: string) => {
		const s = ScenarioFactory.createFetchExcelFileDownload(dispatch, token);
		return s.run(orgId);
	},
	fetchLogFileDownload: (token: string) => {
		const s = ScenarioFactory.createFetchLogFileDownload(dispatch, token);
		return s.run({});
	},
});

const Transition: React.FunctionComponent<any> = props => {
	return <Slide direction="up" {...props} />;
};

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

interface IRouteState {
	org_Id: string;
}

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<{}, StaticContext, IRouteState>;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeStudentAssign);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModeStudentAssign.tsx